import {lazy} from 'react';

import {PreviewSuspense} from 'next-sanity/preview';

import BlogHome from 'components/BlogHome';
import {getAllPostsFromSanityAndMarkdown} from 'utils/blog';

const BlogHomePreview = lazy(async () => await import('components/BlogHomePreview'));

export default function BlogIndexPage(props) {
  const {posts, preview} = props;

  return preview ? (
    <PreviewSuspense fallback="Loading...">
      <BlogHomePreview />
    </PreviewSuspense>
  ) : (
    <BlogHome allPosts={posts} page={props.page} />
  );
}

export async function getStaticProps({preview = false}) {
  if (preview) {
    return {props: {preview}};
  }

  const posts = await getAllPostsFromSanityAndMarkdown();

  return {
    props: {
      page: '1',
      posts,
      preview,
    },
    revalidate: 60,
  };
}
